
import {ExternalIdModel} from "../../../common/externalId/api/entity/externalId.model";
import {LovValueSummary} from "../../../common/lov/lov-value/api/model/lovValueSummary.model";
import {PermissionsModel} from "../../../common/entity/permissions.model";
import {SummaryModel} from "../../../common/entity/summary.model";
import {BaseAuditableDto} from "../../../../shared/model/core/baseAuditableDto.model";
import {UserSummary} from "../../../account/modules/user/api/entity/userSummary.model";

export class  MessageSummaryModel extends BaseAuditableDto implements SummaryModel {
    id: number;
    permissions: PermissionsModel;
    externalId: ExternalIdModel;
    externalProcessId: ExternalIdModel;
    externalProcessStatus: LovValueSummary;
    author: UserSummary;

    get externalProcessInProgress() : boolean {
        return this.externalProcessStatus?.value === 'MESSAGE_EXTERNAL_PROCESS_STATUS_IN_PROGRESS';
    }

    get externalProcessInError() : boolean {
        return this.externalProcessStatus?.value === 'MESSAGE_EXTERNAL_PROCESS_STATUS_ERROR';
    }

}